import { useEffect, useRef, useState, useMemo } from "react";
import {
  ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVES_META_WITH_DESTINATION_TYPE,
  ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_BEHAVIORS_TYPE,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_DEMOGRAPHICS_TYPE,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_INTERESTS_TYPE,
  ADS_CAMPAIGN_SEARCH_SEGMENTATION_LOCATIONS_TYPE,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
  ALERT_ICON_TYPE_SUCCESS,
  BORDER_RADIUS,
  LABELS_TRACKING_CUSTOM_EVENTS,
  LABELS_TRACKING_ID,
  META,
  metaCurrenciesWithDecimals,
  MIN_WIDTH_SCREEN_TO_SHOW_CHAT,
  ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LINK_CLICKS,
  getIsMetaSalesWhatsappDestination,
} from "../../../../utils/constants";
import { useTranslationApp } from "../../../../lib/i18next";
import useFocusErrorForm from "../../../../hooks/useFocusErrorForm";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import {
  People,
  Person,
  Favorite,
  TrendingUp,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LocationOnOutlined,
  AdsClickOutlined,
  Paid,
  Widgets,
  CheckCircle,
} from "@mui/icons-material";
import TextFieldMUI from "@mui/material/TextField";
import { Slider, useMediaQuery, useTheme, InputAdornment } from "@mui/material";
import Select from "../../../Form/Select";
import Switch from "../../../Form/Switch";
import { addDays, differenceInDays, endOfDay, startOfDay } from "date-fns";
import {
  marksAge,
  optionsAdsCampaignTypeBudgets,
} from "../../../../utils/options";
import TextField from "../../../Form/TextField";
import {
  textNumberCompactFormat,
  getUniqueID,
  clampIntegerMetaBudgetPercent,
  metaBudgetAmountFromIntegerPercent,
} from "../../../../utils/numbers";
import AdsGroupFormCustomAudiencesList from "../../../../pages/AdsCampaign/components/AdsGroupFormCustomAudiencesList";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../../../utils/colors";
import { getReactHookFormNestedError } from "../../../../utils/errors";
import CheckBoxes from "../../../Form/CheckBoxes";
import SearchSegmentationsField from "../../../Form/SearchSegmentationsField";
import { waitDelay } from "../../../../utils/date";
import { getCurrencyAdAccountPlatform } from "../../../../actions/getters";
import { useDispatchApp } from "../../../../lib/redux";
import NumberField from "../../../Form/NumberField";
import SelectDestinationTypeMeta from "../../../Meta/SelectDestinationTypeMeta";
import SelectOptimizationGoalMeta from "../../../Meta/SelectOptimizationGoalMeta";
import { ConfirmAlert, SimpleAlert } from "../../../Alerts/Alerts";
import SelectWhatsappBusinessNumber from "../../../Form/SelectWhatsappBusinessNumber";
import SelectTrackingIDField from "../../../Form/SelectTrackingIDField";
import SelectCustomEventAds from "../../../Form/SelectCustomEventAds";
import _ from "lodash";
import ClickableText from "../../../Texts/ClickableText";
import NumberDecimalField from "../../../Form/NumberDecimalField";
import SelectProductsSetMeta from "../Campaign/SelectProductsSetMeta";
import ProductSetAudienceBuilderMeta from "./ProductSetAudienceBuilderMeta";
import SelectAdvertisableAppsMeta from "../Ad/SelectAdvertisableAppsMeta";
import SelectCatalogMeta from "../Campaign/SelectCatalogMeta";
import {
  AD_SCHEDULE_PLACEHOLDER,
  ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE,
  ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE,
  ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE,
  AGE_RANGE_PLACEHOLDER,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION,
  ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE,
  ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION,
  ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION,
  APP_PLACEHOLDER,
  BEHAVIORS_PLACEHOLDER,
  BUDGET_CONFIGURATION_PLACEHOLDER,
  BUTTON_CANCEL,
  BUTTON_CONTINUE,
  CATALOG_PLACEHOLDER,
  COPY_VALUE_IN_OTHER_ADGROUPS,
  DAILY_BUDGET_PLACEHOLDER,
  DEMOGRAPHICS_BASIC_PLACEHOLDER,
  DEMOGRAPHICS_PLACEHOLDER,
  DESTINATION_TYPE_PLACEHOLDER,
  END_DATE_PLACEHOLDER,
  FEMALES,
  FIELD_REQUIRED,
  FIELD_END_DATE_LESS_THAN_NOW,
  FIELD_START_DATE_LESS_THAN_NOW,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER,
  IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER,
  GENDERS_PLACEHOLDER,
  INTERESTS_PLACEHOLDER,
  LANGUAGES_PLACEHOLDER,
  LIFETIME_BUDGET_PLACEHOLDER,
  LOCATIONS_PLACEHOLDER,
  EXCLUDED_LOCATIONS_PLACEHOLDER,
  MALES,
  MAX_DAILY_BUDGET_PLACEHOLDER,
  MAX_TOTAL_BUDGET_PLACEHOLDER,
  META_DESTINATION_TYPE_PLACEHOLDER,
  OPTIMIZATION_GOAL_PLACEHOLDER,
  MIN_DAILY_BUDGET_PLACEHOLDER,
  MIN_TOTAL_BUDGET_PLACEHOLDER,
  PLACEMENTS_PLACEHOLDER,
  FREQUENCY_SPECS_CONTROL_PLACEHOLDER,
  PRODUCT_SET_AUDIENCE_BUILDER_TITLE,
  PROMOTED_PRODUCTS_PLACEHOLDER,
  READY,
  RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION,
  START_DATE_PLACEHOLDER,
  START_DATE_AND_END_DATE_VALIDATION,
  SUGGESTION_BUDGET_APPLY,
  SUGGESTION_BUDGET_CANCEL,
  SUGGESTION_BUDGET_TITLE,
  TRACKING_OFFLINE_EVENTS_PLACEHOLDER,
  TYPE_BUDGET_PLACEHOLDER,
  WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import WeeklyTimeSelector from "../../../../pages/NewAdsCampaign/components/Common/WeeklyTimeSelector";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CachedIcon from "@mui/icons-material/Cached";
import { AdGroupPlacementsMetaForm } from "./AdGroupPlacementsMetaForm";
import DateTimeField from "../../../Form/DateTimeField";
import BidGoalMeta from "./BidGoalMeta";
import BudgetSuggestionsAlert from "../../../Alerts/BudgetSuggestionsAlert";
import AdGroupBTReservedMetaForm from "./AdGroupBTReservedMetaForm";
import FrequencySpecsMeta from "./FrequencySpecsMeta";
import CardContainer from "../../../Card/CardContainer";
import {
  getIsPostAdVisible,
  getMinimumBudget,
} from "../../../../services/adsCampaigns";
import { getIsDynamicCreativeVisible } from "../../../../services/meta";
import SelectLanguagesMetaForm from "./SelectLanguagesMetaForm";
import ChipOptional from "../../../Chip/ChipOptional";
import AudienceEstimatesPreviewMeta from "./AudienceEstimatesPreviewMeta";
import AdsGroupFormChooseSavedAudience from "../../../../pages/AdsCampaign/components/AdsGroupFormChooseSavedAudience";
import GroupsIcon from "@mui/icons-material/Groups";
import { textFieldInputSx } from "../../../../styles";

const platform = META;
const grid = {
  xs: 12,
  lg: 6,
};

const gridDates = {
  xs: 12,
  xl: 6,
};

const getStartOfDayValue = (date) => (date ? startOfDay(date) : null);

const BudgetLimitsModeAdornment = ({
  control,
  errors,
  name,
  currency = "",
  disabled = false,
  onModeChange = () => {},
}) => (
  <InputAdornment position="end" sx={{ ml: 0 }}>
    <Select
      control={control}
      name={name}
      errors={errors}
      options={[
        { value: "currency", label: currency?.toUpperCase() || "" },
        { value: "percentage", label: "%" },
      ]}
      variant="filled"
      rules={{}}
      disabled={disabled}
      fullWidth={false}
      size="small"
      label=""
      actionsChange={onModeChange}
      sx={{
        minWidth: 56,
        border: "none",
        boxShadow: "none",
        "& .MuiInputBase-root": {
          fontSize: 14,
          border: "none",
          boxShadow: "none",
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: { minWidth: 80 },
        },
      }}
    />
  </InputAdornment>
);

// Transforms display value (percentage) <-> form value (currency)
const BudgetLimitsField = ({
  name,
  control,
  errors,
  budgetLimitsMode,
  campaignBudget,
  currency = "",
  InputProps,
  disabled,
  ...rest
}) => {
  const campaignBudgetNum = Number(campaignBudget) || 0;
  const isPercentageMode =
    budgetLimitsMode === "percentage" && campaignBudgetNum > 0;
  const watchedValue = useWatch({
    control,
    name,
  });
  const [displayOverride, setDisplayOverride] = useState(null);

  useEffect(() => {
    if (!isPercentageMode) {
      setDisplayOverride(null);
      return;
    }

    if (displayOverride == null) return;

    const displayNum = Number(displayOverride);
    const overrideFormValue =
      displayOverride === "" || isNaN(displayNum)
        ? ""
        : metaBudgetAmountFromIntegerPercent(
            clampIntegerMetaBudgetPercent(displayNum),
            campaignBudgetNum,
            currency
          );
    const normalizedWatchedValue =
      watchedValue === "" || watchedValue == null ? "" : Number(watchedValue);
    const normalizedOverrideValue =
      overrideFormValue === "" ? "" : Number(overrideFormValue);

    if (normalizedWatchedValue !== normalizedOverrideValue) {
      setDisplayOverride(null);
    }
  }, [
    campaignBudgetNum,
    currency,
    displayOverride,
    isPercentageMode,
    watchedValue,
  ]);

  const toDisplayValue = (formValue) => {
    if (!isPercentageMode) return formValue ?? "";
    const num = Number(formValue);
    if (!num || isNaN(num)) return "";
    const pct = Math.round((num / campaignBudgetNum) * 100);
    return String(clampIntegerMetaBudgetPercent(pct));
  };

  const toFormValue = (displayValue) => {
    if (!isPercentageMode) return displayValue;
    const num = Number(displayValue);
    if (displayValue === "" || displayValue == null || isNaN(num)) return "";
    return metaBudgetAmountFromIntegerPercent(
      clampIntegerMetaBudgetPercent(num),
      campaignBudgetNum,
      currency
    );
  };

  const error = getReactHookFormNestedError(errors, name);

  return (
    <Controller
      control={control}
      name={name}
      rules={{}}
      render={({ field }) => {
        const displayValue = toDisplayValue(field.value);
        const renderedValue =
          isPercentageMode && displayOverride !== null
            ? displayOverride
            : displayValue;
        return (
          <TextFieldMUI
            {...rest}
            name={name}
            disabled={disabled}
            variant="filled"
            fullWidth
            hiddenLabel={true}
            error={!!error}
            helperText={error?.message}
            InputProps={{
              ...InputProps,
              inputComponent: isPercentageMode
                ? NumberField
                : InputProps?.inputComponent,
            }}
            value={renderedValue}
            onChange={(e) => {
              const raw = e?.target?.value ?? "";
              const formValue = toFormValue(raw);
              setDisplayOverride(
                isPercentageMode ? (raw === "" ? "" : String(raw)) : null
              );
              field.onChange(formValue === "" ? "" : formValue);
            }}
            onBlur={() => {
              field.onBlur();
              if (
                isPercentageMode &&
                displayOverride !== null &&
                displayOverride !== ""
              ) {
                const n = Number(displayOverride);
                if (!isNaN(n)) {
                  setDisplayOverride(String(clampIntegerMetaBudgetPercent(n)));
                }
              }
            }}
            inputRef={field.ref}
            sx={textFieldInputSx}
          />
        );
      }}
    />
  );
};

const AdGroupMetaForm = () => {
  const isFirstRender = useRef(true);
  const [pixels, setPixels] = useState([]);
  const [productSetSelected, setProductSetSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const {
    control,
    formState,
    setValue,
    watch,
    sectionSelected,
    isGeneralDisabledFields,
    getValues,
    currencyTaxes,
    trigger,
    isChatVisible,
  } = useFormContext();
  useFocusErrorForm(formState);

  const errors = formState.errors;

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const isLargeScreen = useMediaQuery(
    () => `(min-width: ${MIN_WIDTH_SCREEN_TO_SHOW_CHAT}px)`
  );
  const showSlideChat = isChatVisible && isLargeScreen;

  const adsGroups = watch("adsGroups") || [];
  const adGroupID = sectionSelected.adGroupID;
  const index = adsGroups.findIndex((item) => item.id === adGroupID);
  const BASIC_PATH = `adsGroups.[${index}]`;
  const status = watch(`${BASIC_PATH}.status`) || ADS_CAMPAIGN_STATUS_DRAFT;
  const platformData = watch(`platformsData.${platform}`) || {};
  const isIOS14Campaign = platformData?.isIOS14Campaign;
  const isIncompatibleCampaign = platformData?.isIncompatible;
  const isAdGroupCreated = status !== ADS_CAMPAIGN_STATUS_DRAFT;

  const useCampaignBudget = platformData?.useCampaignBudget || false;
  const budgetLimitsMode = watch(`${BASIC_PATH}.budgetLimitsMode`);
  const objective = platformData?.objective;
  const isCatalogCampaign = platformData?.isCatalogCampaign || false;
  const catalogIDCampaign = platformData?.catalogID || "";
  const buyingType = platformData?.buyingType;
  const specialAdCategories = platformData?.specialAdCategories || [];
  const hasSpecialAdCategories = specialAdCategories?.length > 0;
  const genders = watch(`${BASIC_PATH}.genders`) || {};
  const catalogIDAdGroup = watch(`${BASIC_PATH}.catalogID`) || "";
  const typeBudget = watch(`${BASIC_PATH}.typeBudget`) || "";
  const language = watch("language") || "";
  const startDate = watch(`${BASIC_PATH}.startDate`) || null;
  const trackingID = watch(`${BASIC_PATH}.trackingID`) || "";
  const endDate = watch(`${BASIC_PATH}.endDate`) || null;
  const customAudiences = watch(`${BASIC_PATH}.customAudiences`) || [];
  const isIncompatibleAdGroup = watch(`${BASIC_PATH}.isIncompatible`) || false;
  const destinationType =
    watch(`${BASIC_PATH}.destinationType`) ||
    ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION;
  const optimizationGoal = watch(`${BASIC_PATH}.optimizationGoal`) || null;
  const isDynamicCreative = watch(`${BASIC_PATH}.isDynamicCreative`) || false;

  const disabledSchedule =
    isAdGroupCreated &&
    useCampaignBudget &&
    typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION;
  const isTotalBudget =
    useCampaignBudget ||
    typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION;

  const isDisabledFields =
    isGeneralDisabledFields || isIncompatibleCampaign || isIncompatibleAdGroup;

  const pixelSelected = _.isEmpty(pixels)
    ? {}
    : pixels.find((p) => p.id === trackingID);
  const hasCustomAudiences = customAudiences?.length > 0;

  const currency = dispatch(
    getCurrencyAdAccountPlatform({
      platform,
      integrationID: platformData?.integrationID,
      adAccountID: platformData?.adAccountID,
    })
  );
  const currencyTax = currencyTaxes?.[currency] || 1;

  const adGroupBudget = watch(`${BASIC_PATH}.budget`) || null;
  const isEffectiveBudget = adGroupBudget > 0;

  const initialDatesRef = useRef({
    startDate: getStartOfDayValue(startDate),
    endDate: getStartOfDayValue(endDate),
  });

  useEffect(() => {
    if (useCampaignBudget && !budgetLimitsMode) {
      setValue(`${BASIC_PATH}.budgetLimitsMode`, "currency");
    }
  }, [useCampaignBudget, budgetLimitsMode, setValue, BASIC_PATH]);

  // Extract complex expressions to memoized variables for static checking
  const startDateValue = useMemo(
    () => getStartOfDayValue(startDate)?.getTime() ?? null,
    [startDate]
  );
  const endDateValue = useMemo(
    () => getStartOfDayValue(endDate)?.getTime() ?? null,
    [endDate]
  );

  useEffect(() => {
    if (buyingType === ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION) {
      return;
    }
    initialDatesRef.current = {
      startDate: getStartOfDayValue(startDate),
      endDate: getStartOfDayValue(endDate),
    };
    // eslint-disable-next-line
  }, [typeBudget]);

  useEffect(() => {
    if (buyingType === ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION) {
      return;
    }
    if (isFirstRender.current) {
      isFirstRender.current = false;
      initialDatesRef.current = {
        startDate: getStartOfDayValue(startDate),
        endDate: getStartOfDayValue(endDate),
      };
      return;
    }

    const onBudgetSuggestion = async () => {
      if (
        typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION &&
        isEffectiveBudget
      ) {
        const initialStart = initialDatesRef.current.startDate;
        const initialEnd = initialDatesRef.current.endDate;
        const currentStartDay = getStartOfDayValue(startDate);
        const currentEndDay = getStartOfDayValue(endDate);

        if (
          !initialStart ||
          !initialEnd ||
          !currentStartDay ||
          !currentEndDay
        ) {
          initialDatesRef.current = {
            startDate: currentStartDay,
            endDate: currentEndDay,
          };
          return;
        }

        const initialDays = differenceInDays(initialEnd, initialStart) || 1;
        const newDays = differenceInDays(currentEndDay, currentStartDay) || 1;

        if (newDays > initialDays) {
          const budgetMinimum = getMinimumBudget({
            platform,
            typeBudget,
            startDateTime: currentStartDay,
            endDateTime: currentEndDay,
            currency,
            currencyTax,
          });

          const dailyBudget = adGroupBudget / initialDays;
          const suggestedBudget = Math.round(dailyBudget * newDays);

          const result = await ConfirmAlert({
            title: t(SUGGESTION_BUDGET_TITLE),
            html: (
              <BudgetSuggestionsAlert
                effectiveBudget={adGroupBudget}
                budgetMinimum={budgetMinimum}
                suggestedBudget={suggestedBudget}
                currency={currency}
              />
            ),
            confirmButtonText: t(SUGGESTION_BUDGET_APPLY),
            cancelButtonText: t(SUGGESTION_BUDGET_CANCEL),
          });
          if (result.isConfirmed) {
            setValue(`${BASIC_PATH}.budget`, suggestedBudget);
            initialDatesRef.current = {
              startDate: currentStartDay,
              endDate: currentEndDay,
            };
          }
        }
      }
    };

    onBudgetSuggestion();
    // eslint-disable-next-line
  }, [startDateValue, endDateValue, typeBudget]);

  const onChangeIsDynamicCreative = async (newValue) => {
    if (newValue) {
      const result = await ConfirmAlert({
        title: t(ALERT_IS_DYNAMIC_CREATIVE_ON_TITLE),
        html: t(ALERT_IS_DYNAMIC_CREATIVE_ON_DESCRIPTION),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });
      if (!result.isConfirmed) return;
      const ads = getValues(`${BASIC_PATH}.ads`) || [];
      const firstAd = ads[0];
      if (ads.length > 1) {
        setValue(`${BASIC_PATH}.ads`, [firstAd], {
          shouldDirty: true,
        });
      }
      if (firstAd) {
        const callToAction = firstAd?.callToAction;
        setValue(
          `${BASIC_PATH}.ads.[0].callToActions`,
          callToAction ? [callToAction] : [],
          { shouldDirty: true }
        );
        const destUrls = firstAd?.destinationUrls || [];
        const firstDestUrl = destUrls[0] || { id: getUniqueID(), value: "" };
        setValue(`${BASIC_PATH}.ads.[0].destinationUrls`, [firstDestUrl], {
          shouldDirty: true,
        });
      }
      setValue(`${BASIC_PATH}.isDynamicCreative`, true);
      setValue(
        `${BASIC_PATH}.destinationType`,
        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
      );
    } else {
      const result = await ConfirmAlert({
        title: t(ALERT_IS_DYNAMIC_CREATIVE_OFF_TITLE),
        html: t(ALERT_IS_DYNAMIC_CREATIVE_OFF_DESCRIPTION),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });
      if (!result.isConfirmed) return;
      const ads = getValues(`${BASIC_PATH}.ads`) || [];
      const ad = ads[0];
      if (ad) {
        const firstOrEmpty = (arr, defaultItem) =>
          Array.isArray(arr) && arr.length > 0 ? arr.slice(0, 1) : defaultItem;
        const emptyTextItem = () => ({
          id: getUniqueID(),
          value: "",
        });
        const resetAd = {
          ...ad,
          mediaData: firstOrEmpty(ad.mediaData, []),
          mediaUrls: firstOrEmpty(ad.mediaUrls, []),
          descriptions: firstOrEmpty(ad.descriptions, [emptyTextItem()]),
          headlines: firstOrEmpty(ad.headlines, [emptyTextItem()]),
          titles: firstOrEmpty(ad.titles, [emptyTextItem()]),
          destinationUrls: firstOrEmpty(ad.destinationUrls, [emptyTextItem()]),
          callToAction: ad.callToActions?.[0] || ad.callToAction || "",
          callToActions: undefined,
        };
        setValue(`${BASIC_PATH}.ads`, [resetAd], {
          shouldDirty: true,
        });
      }
      setValue(`${BASIC_PATH}.isDynamicCreative`, false);
    }
  };

  const onChangeDestinationType = (value) => {
    const adGroup = adsGroups[index];
    const ads = adGroup?.ads || [];
    const isDynamicCreative = adGroup?.isDynamicCreative;

    const showIsPostAd = getIsPostAdVisible({
      objective,
      destinationType: value,
    });

    const isDestinationPost =
      value === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION;

    if (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION) {
      if (value === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION) {
        setValue(
          `${BASIC_PATH}.optimizationGoal`,
          optimizationGoal || ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LINK_CLICKS
        );
      } else {
        setValue(`${BASIC_PATH}.optimizationGoal`, null);
      }
    }

    ads.forEach((ad, indexAd) => {
      const currentCallToAction = isDynamicCreative
        ? ad?.callToActions?.[0]
        : ad?.callToAction;
      const callToAction =
        value === ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION
          ? "VIEW_INSTAGRAM_PROFILE"
          : currentCallToAction === "VIEW_INSTAGRAM_PROFILE"
            ? ""
            : currentCallToAction;
      if (isDynamicCreative) {
        setValue(
          `adsGroups.[${index}].ads.[${indexAd}].callToActions`,
          callToAction ? [callToAction] : [],
          { shouldDirty: true }
        );
      } else {
        setValue(
          `adsGroups.[${index}].ads.[${indexAd}].callToAction`,
          callToAction
        );
      }

      if (isDestinationPost) {
        setValue(`adsGroups.[${index}].ads.[${indexAd}].isCarousel`, false);
        setValue(
          `adsGroups.[${index}].ads.[${indexAd}].isInstantExperience`,
          false
        );
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaUrls`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaData`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
        setValue(
          `adsGroups.[${index}].ads.[${indexAd}].creativeSource`,
          ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES.MANUAL
        );
      }

      if (ad.isPostAd && !showIsPostAd) {
        setValue(`adsGroups.[${index}].ads.[${indexAd}].isPostAd`, false);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaUrls`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaData`, []);
        setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
      }

      setValue(
        `adsGroups.[${index}].ads.[${indexAd}].destinationType`,
        ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION
      );
    });
  };

  const onChangeOptimizationGoal = (value) => {
    if (value !== ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY) {
      return;
    }

    const adGroup = adsGroups[index];
    const ads = adGroup?.ads || [];
    ads.forEach((_ad, indexAd) => {
      setValue(`adsGroups.[${index}].ads.[${indexAd}].isCarousel`, false);
    });
  };

  const validationChangeDestinationType = async (newDestinationType) => {
    if (
      (destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION &&
        newDestinationType !==
          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION) ||
      (destinationType !== ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION &&
        newDestinationType ===
          ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION)
    ) {
      const result = await ConfirmAlert({
        title: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_TITLE
        ),
        text: t(
          ALERT_CHANGE_OBJECTIVE_OR_DESTINATION_TYPE_AFFECT_MEDIA_URLS_DESCRIPTION
        ),
        confirmButtonText: t(BUTTON_CONTINUE),
        cancelButtonText: t(BUTTON_CANCEL),
      });

      if (!result.isConfirmed) return false;

      onCleanMediaUrls();
    }

    return true;
  };

  const onCleanMediaUrls = () => {
    const adGroup = adsGroups[index];
    const ads = adGroup?.ads || [];

    ads.forEach((ad, indexAd) => {
      setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaUrls`, []);
      setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaData`, []);
      setValue(`adsGroups.[${index}].ads.[${indexAd}].mediaIDs`, []);
    });
  };
  const onSetProductSetID = (value = "") => {
    setValue(`${BASIC_PATH}.productSetID`, value);
    const adGroup = adsGroups[index];
    const ads = adGroup?.ads || [];

    ads.forEach((ad, indexAd) => {
      setValue(`adsGroups.[${index}].ads.[${indexAd}].productSetID`, value);
    });
  };

  const onCopyValuesInOtherAds = ({ type }) => {
    const value = getValues(`${BASIC_PATH}.${type}`);
    const adsGroups = getValues(`adsGroups`);

    adsGroups.forEach((adGroup, currentIndexAdGroup) => {
      if (adGroup.platform !== platform) return;

      setValue(`adsGroups.[${currentIndexAdGroup}].${type}`, value);
    });

    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  //To reset values component when change selectedLevel
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await waitDelay(1);
      setIsLoading(false);
    })();
  }, [sectionSelected]);

  const [interestsOpen, setInterestsOpen] = useState(true);
  const [behaviorOpen, setBehaviorOpen] = useState(true);
  const [demographyOpen, setDemographyOpen] = useState(true);

  if (isLoading) return null;

  //LOGIC RENDER CARD: Destination Type configuration
  const showDestinationType =
    ADS_CAMPAIGN_OBJECTIVES_META_WITH_DESTINATION_TYPE.includes(objective) &&
    !isCatalogCampaign;
  const showAppPromotion =
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
      destinationType
    ) ||
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID.includes(destinationType);
  const showWhatsapp =
    destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION;

  const showOptimizationGoal =
    objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION ||
    (objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION &&
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION);

  const showIsDynamicCreativeSection = getIsDynamicCreativeVisible({
    objective,
    destinationType,
  });

  const showTrackingID =
    ((ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID.includes(
        destinationType
      )) ||
      getIsMetaSalesWhatsappDestination({ objective, destinationType })) &&
    !isCatalogCampaign;

  const showOfflineTrackingID =
    ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
    ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID.includes(
      destinationType
    );
  !isCatalogCampaign;

  const showCustomEventID =
    (ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META.includes(objective) &&
      destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION) ||
    getIsMetaSalesWhatsappDestination({ objective, destinationType }) ||
    isCatalogCampaign ||
    (showAppPromotion &&
      objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
      !ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID.includes(
        destinationType
      ));

  const fieldsToRender = [
    showDestinationType,
    showOptimizationGoal,
    showAppPromotion,
    showWhatsapp,
    showTrackingID,
    showCustomEventID,
  ].filter(Boolean);

  const shouldRenderCard = fieldsToRender.length > 0;
  const gridXS = fieldsToRender.length > 1 ? 6 : 12;

  if (buyingType === ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION) {
    return <AdGroupBTReservedMetaForm />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: isTabletOrMobile || showSlideChat ? "column" : "row",
        gap: 2,
      }}
    >
      {/* Forms Column */}
      <Box
        sx={{
          flex: 1,
          maxWidth:
            isTabletOrMobile || showSlideChat ? "100%" : "calc(100% - 420px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 3,
          order: isTabletOrMobile || showSlideChat ? 2 : 1,
        }}
      >
        {/* CARD: Destination type configuration */}
        {shouldRenderCard && (
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <AdsClickOutlined
                  sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(DESTINATION_TYPE_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <Grid container spacing={2}>
              {/* CARD:  Destination Type configuration */}
              {showDestinationType && (
                <Grid item xs={gridXS}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(META_DESTINATION_TYPE_PLACEHOLDER)}
                    </Typography>
                    <SelectDestinationTypeMeta
                      label={""}
                      name={`${BASIC_PATH}.destinationType`}
                      objective={objective}
                      variant="filled"
                      fullWidth={true}
                      disabled={
                        isAdGroupCreated || isDisabledFields || isIOS14Campaign
                      }
                      onlyOptionsAllowed={
                        isDynamicCreative
                          ? [
                              ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
                              ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
                            ]
                          : []
                      }
                      control={control}
                      errors={errors}
                      actionsChange={(value) => {
                        onChangeDestinationType(value);
                        if (
                          ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE.includes(
                            value
                          )
                        ) {
                          const ads = getValues(`${BASIC_PATH}.ads`) || [];
                          ads.forEach((ad, indexAd) => {
                            if (ad.isInstantExperience) {
                              setValue(
                                `${BASIC_PATH}.ads.[${indexAd}].instantExperience`,
                                null
                              );
                            }
                          });
                        }
                      }}
                      validationChange={validationChangeDestinationType}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                  </Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "destinationType" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Grid>
              )}

              {showOptimizationGoal && (
                <Grid item xs={gridXS}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(OPTIMIZATION_GOAL_PLACEHOLDER)}
                    </Typography>
                    <SelectOptimizationGoalMeta
                      label={""}
                      name={`${BASIC_PATH}.optimizationGoal`}
                      objective={objective}
                      destinationType={destinationType}
                      variant="filled"
                      fullWidth={true}
                      disabled={isAdGroupCreated || isDisabledFields}
                      control={control}
                      errors={errors}
                      actionsChange={onChangeOptimizationGoal}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                  </Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "optimizationGoal" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Grid>
              )}

              {/* CARD: App promotion campaign configuration */}
              {showAppPromotion && (
                <>
                  <Grid item xs={gridXS}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 1,
                      }}
                    >
                      <Typography variant="body1">
                        {t(APP_PLACEHOLDER)}
                      </Typography>

                      <SelectAdvertisableAppsMeta
                        disabled={
                          isAdGroupCreated ||
                          isDisabledFields ||
                          isIOS14Campaign
                        }
                        platform={META}
                        label={""}
                        adAccountID={platformData?.adAccountID}
                        integrationID={platformData?.integrationID}
                        name={`${BASIC_PATH}.appID`}
                        fullWidth
                        variant="filled"
                        control={control}
                        errors={errors}
                        onChangeAction={() => {
                          const ads = getValues(`${BASIC_PATH}.ads`) || [];
                          ads.forEach((ad, indexAd) => {
                            if (ad.isInstantExperience) {
                              setValue(
                                `${BASIC_PATH}.ads.[${indexAd}].instantExperience`,
                                null
                              );
                            }
                          });
                        }}
                      />
                    </Box>
                    <ClickableText
                      onClick={() => onCopyValuesInOtherAds({ type: "appID" })}
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Grid>

                  {catalogIDAdGroup && (
                    <>
                      <Grid item xs={gridXS}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          <Typography variant="body1">
                            {t(CATALOG_PLACEHOLDER)}
                          </Typography>
                          <SelectCatalogMeta
                            label={""}
                            fullWidth
                            disabled={isAdGroupCreated || isDisabledFields}
                            variant="filled"
                            platform={META}
                            integrationID={platformData?.integrationID}
                            adAccountID={platformData?.adAccountID}
                            control={control}
                            name={`${BASIC_PATH}.catalogID`}
                            disableClearable={true}
                            onChangeAction={() => onSetProductSetID()}
                            errors={errors}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={gridXS}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: 1,
                          }}
                        >
                          <Typography variant="body1">
                            {t(PROMOTED_PRODUCTS_PLACEHOLDER)}
                          </Typography>
                          <SelectProductsSetMeta
                            label={""}
                            fullWidth
                            variant="filled"
                            disabled={isAdGroupCreated || isDisabledFields}
                            platform={META}
                            integrationID={platformData?.integrationID}
                            adAccountID={platformData?.adAccountID}
                            onChangeAction={(value) => {
                              setProductSetSelected(value);
                              onSetProductSetID(value?.id || value || "");
                            }}
                            catalogID={catalogIDAdGroup}
                            control={control}
                            name={`${BASIC_PATH}.productSetID`}
                            errors={errors}
                            disableClearable={true}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                </>
              )}

              {/* Whatsapp campaign configuration */}
              {showWhatsapp && (
                <Grid item xs={gridXS}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(WHATSAPP_BUSINESS_NUMBER_PLACEHOLDER)}
                    </Typography>

                    <SelectWhatsappBusinessNumber
                      label={""}
                      name={`${BASIC_PATH}.whatsappBusinessNumber`}
                      integrationID={platformData?.integrationID}
                      adAccountID={platformData?.adAccountID}
                      pageID={platformData?.pageID}
                      disabled={isAdGroupCreated || isDisabledFields}
                      fullWidth
                      variant="filled"
                      control={control}
                      errors={errors}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                  </Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({
                        type: "whatsappBusinessNumber",
                      })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Grid>
              )}

              {/* Meta Pixel configuration */}
              {showTrackingID && (
                <Grid item xs={gridXS}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(LABELS_TRACKING_ID[platform])}
                    </Typography>

                    <SelectTrackingIDField
                      name={`${BASIC_PATH}.trackingID`}
                      disabled={isAdGroupCreated || isDisabledFields}
                      label={""}
                      fullWidth
                      variant="filled"
                      platform={platform}
                      integrationID={platformData?.integrationID}
                      adAccountID={platformData?.adAccountID}
                      onLoadOptions={(newPixels) => {
                        setPixels(newPixels);
                      }}
                      onChangeAction={() => {
                        setValue(`${BASIC_PATH}.trackingCustomEventID`, "");
                      }}
                      control={control}
                      errors={errors}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                  </Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "trackingID" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Grid>
              )}

              {showOfflineTrackingID && (
                <Grid item xs={gridXS}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(TRACKING_OFFLINE_EVENTS_PLACEHOLDER)}
                    </Typography>

                    <SelectTrackingIDField
                      name={`${BASIC_PATH}.trackingOfflineID`}
                      disabled={isAdGroupCreated || isDisabledFields}
                      label={""}
                      fullWidth
                      variant="filled"
                      platform={platform}
                      integrationID={platformData?.integrationID}
                      adAccountID={platformData?.adAccountID}
                      onLoadOptions={(newPixels) => {
                        setPixels(newPixels);
                      }}
                      control={control}
                      errors={errors}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                  </Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "trackingOfflineID" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Grid>
              )}

              {/* Tracking Custom Event ID configuration */}
              {showCustomEventID && (
                <Grid item xs={gridXS}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(LABELS_TRACKING_CUSTOM_EVENTS[platform])}
                    </Typography>

                    <SelectCustomEventAds
                      label={""}
                      name={`${BASIC_PATH}.trackingCustomEventID`}
                      platform={platform}
                      variant="filled"
                      disabled={isAdGroupCreated || isDisabledFields}
                      integrationID={platformData?.integrationID}
                      adAccountID={platformData?.adAccountID}
                      trackingID={trackingID}
                      isCatalogCampaign={isCatalogCampaign}
                      pixelSelected={pixelSelected}
                      objective={objective}
                      control={control}
                      errors={errors}
                      fullWidth={true}
                      rules={{
                        required: {
                          value: true,
                          message: t(FIELD_REQUIRED),
                        },
                      }}
                    />
                  </Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({
                        type: "trackingCustomEventID",
                      })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Grid>
              )}
            </Grid>
          </CardContainer>
        )}

        {/* Dynamic Creative section */}
        {showIsDynamicCreativeSection && (
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CheckCircle sx={{ color: "#4caf50", width: 24, height: 24 }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_QUESTION)}
                </Typography>
              </Box>
            }
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 0.5,
              }}
            >
              <Controller
                name={`${BASIC_PATH}.isDynamicCreative`}
                control={control}
                render={({ field }) => (
                  <Switch
                    disabled={isAdGroupCreated || isDisabledFields}
                    isActive={Boolean(field.value)}
                    hasLabel={true}
                    labelActive={
                      ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION
                    }
                    labelDeactivate={
                      ADS_CAMPAIGN_META_IS_DYNAMIC_CREATIVE_DESCRIPTION
                    }
                    sxLabel={{
                      ".MuiFormControlLabel-label": {
                        fontSize: "0.9rem",
                        fontWeight: 400,
                      },
                    }}
                    onChangeIsActive={(newValue) => {
                      onChangeIsDynamicCreative(newValue);
                    }}
                  />
                )}
              />
            </Box>
          </CardContainer>
        )}

        {/* Catalog campaign configuration */}
        {isCatalogCampaign && (
          <>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Widgets
                    sx={{
                      color: "#FFFFFF",
                      width: 24,
                      height: 24,
                      fontWeight: 600,
                    }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(ADS_CAMPAIGN_AD_GROUP_PRODUCTS_SUB_TITLE)}
                  </Typography>
                </Box>
              }
            >
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {t(PROMOTED_PRODUCTS_PLACEHOLDER)}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <SelectProductsSetMeta
                  fullWidth
                  variant="filled"
                  disabled={isAdGroupCreated || isDisabledFields}
                  platform={META}
                  integrationID={platformData?.integrationID}
                  adAccountID={platformData?.adAccountID}
                  onChangeAction={(value) => {
                    setProductSetSelected(value);
                    onSetProductSetID(value?.id || value || "");
                  }}
                  catalogID={catalogIDCampaign}
                  control={control}
                  name={`${BASIC_PATH}.productSetID`}
                  errors={errors}
                />
              </Grid>
            </CardContainer>

            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <People
                    sx={{
                      color: "#FFFFFF",
                      width: 24,
                      height: 24,
                      fontWeight: 600,
                    }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(PRODUCT_SET_AUDIENCE_BUILDER_TITLE)}
                  </Typography>
                </Box>
              }
            >
              {productSetSelected && (
                <>
                  <Grid item xs={12} />
                  <Grid item xs={12}>
                    <ProductSetAudienceBuilderMeta
                      control={control}
                      name={`${BASIC_PATH}.productSetAudience`}
                      productSetSelected={productSetSelected}
                      catalogID={catalogIDCampaign}
                      integrationID={platformData?.integrationID}
                      adAccountID={platformData?.adAccountID}
                      errors={errors}
                    />
                  </Grid>
                </>
              )}
            </CardContainer>
          </>
        )}

        {/* Budget configuration */}

        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Paid sx={{ color: "#FFFFFF", width: 24, height: 24 }} />

              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(BUDGET_CONFIGURATION_PLACEHOLDER)}
              </Typography>
            </Box>
          }
        >
          <Grid container spacing={3}>
            {/* Budget configuration */}
            {!useCampaignBudget && (
              <>
                <Grid item {...grid}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(TYPE_BUDGET_PLACEHOLDER)}
                    </Typography>
                    <Select
                      label={""}
                      disabled={isAdGroupCreated || isDisabledFields}
                      name={`${BASIC_PATH}.typeBudget`}
                      actionsChange={(value) => {
                        if (
                          value === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION
                        ) {
                          setValue(
                            `${BASIC_PATH}.startDate`,
                            startOfDay(new Date())
                          );
                          setValue(
                            `${BASIC_PATH}.endDate`,
                            endOfDay(addDays(new Date(), 1))
                          );
                        }
                      }}
                      fullWidth
                      variant="filled"
                      doTranslate={true}
                      options={optionsAdsCampaignTypeBudgets}
                      control={control}
                      errors={errors}
                      rules={{}}
                    />
                    <ClickableText
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "typeBudget" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Box>
                </Grid>
                <Grid item {...grid}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Typography variant="body1">
                      {t(
                        typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION
                          ? DAILY_BUDGET_PLACEHOLDER
                          : LIFETIME_BUDGET_PLACEHOLDER,
                        {
                          currency: currency.toUpperCase(),
                        }
                      )}
                    </Typography>
                    <TextField
                      name={`${BASIC_PATH}.budget`}
                      disabled={isDisabledFields}
                      fullWidth
                      variant="filled"
                      InputProps={{
                        inputComponent: metaCurrenciesWithDecimals.includes(
                          currency
                        )
                          ? NumberDecimalField
                          : NumberField,
                      }}
                      control={control}
                      errors={errors}
                      rules={{}}
                    />
                    <ClickableText
                      onClick={() => onCopyValuesInOtherAds({ type: "budget" })}
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Box>
                </Grid>
              </>
            )}
            {/* Budget configuration */}
            <>
              <Grid item {...gridDates}>
                <Typography sx={{ mb: 1 }} variant="body1">
                  {t(START_DATE_PLACEHOLDER)}
                </Typography>
                <DateTimeField
                  disabled={(isAdGroupCreated || isDisabledFields) && startDate}
                  minDate={startOfDay(new Date())}
                  name={`${BASIC_PATH}.startDate`}
                  id={`${BASIC_PATH}.startDate`}
                  control={control}
                  errors={errors}
                  showStartNowButton={true}
                  rules={{
                    validate: (value) => {
                      if (!value) {
                        return t(FIELD_REQUIRED);
                      }

                      const startDateValue = new Date(value);
                      const startDateMin = startOfDay(new Date());
                      if (
                        startDateValue.getTime() < startDateMin.getTime() &&
                        !isAdGroupCreated
                      ) {
                        return t(FIELD_START_DATE_LESS_THAN_NOW);
                      }

                      if (endDate) {
                        const endDateValue = new Date(endDate);
                        if (startDateValue.getTime() > endDateValue.getTime()) {
                          return t(START_DATE_AND_END_DATE_VALIDATION);
                        }
                      }

                      return true;
                    },
                  }}
                />
                <ClickableText
                  onClick={() => onCopyValuesInOtherAds({ type: "startDate" })}
                >
                  {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                </ClickableText>
              </Grid>
              <Grid item {...gridDates}>
                <Typography sx={{ mb: 1 }} variant="body1">
                  {t(END_DATE_PLACEHOLDER)}
                </Typography>
                <DateTimeField
                  disabled={isDisabledFields}
                  name={`${BASIC_PATH}.endDate`}
                  id={`${BASIC_PATH}.endDate`}
                  minDate={addDays(new Date(startDate || new Date()), 1)}
                  actionsChange={() => {
                    trigger(`${BASIC_PATH}.budget`);
                  }}
                  control={control}
                  errors={errors}
                  rules={{
                    validate: (value) => {
                      if (!value) {
                        if (isTotalBudget) {
                          return t(FIELD_REQUIRED);
                        }
                        return true;
                      }

                      const endDateValue = new Date(value);
                      if (endDateValue.getTime() < new Date().getTime()) {
                        return t(FIELD_END_DATE_LESS_THAN_NOW);
                      }

                      if (startDate) {
                        const startDateValue = new Date(startDate);
                        if (startDateValue.getTime() > endDateValue.getTime()) {
                          return t(START_DATE_AND_END_DATE_VALIDATION);
                        }
                      }

                      return true;
                    },
                  }}
                />
                <ClickableText
                  onClick={() => onCopyValuesInOtherAds({ type: "endDate" })}
                >
                  {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                </ClickableText>
              </Grid>
            </>
            {useCampaignBudget && (
              <>
                <Grid item {...grid}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="body1">
                        {t(
                          typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION
                            ? MIN_DAILY_BUDGET_PLACEHOLDER
                            : MIN_TOTAL_BUDGET_PLACEHOLDER,
                          {
                            currency: currency.toUpperCase(),
                          }
                        )}
                      </Typography>
                      <ChipOptional size="small" />
                    </Box>
                    <BudgetLimitsField
                      name={`${BASIC_PATH}.minBudget`}
                      disabled={isDisabledFields}
                      control={control}
                      errors={errors}
                      currency={currency}
                      budgetLimitsMode={watch(`${BASIC_PATH}.budgetLimitsMode`)}
                      campaignBudget={platformData?.budget}
                      InputProps={{
                        inputComponent: metaCurrenciesWithDecimals.includes(
                          currency
                        )
                          ? NumberDecimalField
                          : NumberField,
                        endAdornment: isDisabledFields ? null : (
                          <BudgetLimitsModeAdornment
                            control={control}
                            errors={errors}
                            name={`${BASIC_PATH}.budgetLimitsMode`}
                            currency={currency}
                            disabled={isDisabledFields}
                            onModeChange={() => {
                              setValue(`${BASIC_PATH}.minBudget`, "");
                              setValue(`${BASIC_PATH}.maxBudget`, "");
                            }}
                          />
                        ),
                      }}
                    />
                    <ClickableText
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "minBudget" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Box>
                </Grid>
                <Grid item {...grid}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography variant="body1">
                        {t(
                          typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION
                            ? MAX_DAILY_BUDGET_PLACEHOLDER
                            : MAX_TOTAL_BUDGET_PLACEHOLDER,
                          {
                            currency: currency.toUpperCase(),
                          }
                        )}
                      </Typography>
                      <ChipOptional size="small" />
                    </Box>
                    <BudgetLimitsField
                      name={`${BASIC_PATH}.maxBudget`}
                      disabled={isDisabledFields}
                      control={control}
                      errors={errors}
                      currency={currency}
                      budgetLimitsMode={watch(`${BASIC_PATH}.budgetLimitsMode`)}
                      campaignBudget={platformData?.budget}
                      InputProps={{
                        inputComponent: metaCurrenciesWithDecimals.includes(
                          currency
                        )
                          ? NumberDecimalField
                          : NumberField,
                        endAdornment: isDisabledFields ? null : (
                          <BudgetLimitsModeAdornment
                            control={control}
                            errors={errors}
                            name={`${BASIC_PATH}.budgetLimitsMode`}
                            currency={currency}
                            disabled={isDisabledFields}
                            onModeChange={() => {
                              setValue(`${BASIC_PATH}.minBudget`, "");
                              setValue(`${BASIC_PATH}.maxBudget`, "");
                            }}
                          />
                        ),
                      }}
                    />
                    <ClickableText
                      onClick={() =>
                        onCopyValuesInOtherAds({ type: "maxBudget" })
                      }
                    >
                      {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                    </ClickableText>
                  </Box>
                </Grid>
              </>
            )}
            <Grid item {...grid}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <BidGoalMeta
                  currency={currency}
                  objective={objective}
                  destinationType={destinationType}
                  optimizationGoal={optimizationGoal}
                  disabled={isDisabledFields}
                  control={control}
                  errors={errors}
                  name={`${BASIC_PATH}.bidGoal`}
                />
                <ClickableText
                  onClick={() => onCopyValuesInOtherAds({ type: "bidGoal" })}
                >
                  {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                </ClickableText>
              </Box>
            </Grid>
          </Grid>
        </CardContainer>

        {/* Frequency Specs - Solo para awareness */}
        {objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION && (
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CachedIcon
                  sx={{
                    color: "#FFFFFF",
                    width: 24,
                    height: 24,
                    fontWeight: 600,
                  }}
                />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(FREQUENCY_SPECS_CONTROL_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <FrequencySpecsMeta
              name={`${BASIC_PATH}.frequency`}
              control={control}
              disabled={isAdGroupCreated || isDisabledFields}
            />
            <Box sx={{ mt: 2 }}>
              <ClickableText
                onClick={() => onCopyValuesInOtherAds({ type: "frequency" })}
              >
                {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
              </ClickableText>
            </Box>
          </CardContainer>
        )}

        {/* Card Ad schedule */}
        {typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION && (
          <CardContainer
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CalendarMonthIcon
                  sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {t(AD_SCHEDULE_PLACEHOLDER)}
                </Typography>
              </Box>
            }
          >
            <WeeklyTimeSelector
              name={`${BASIC_PATH}.schedule`}
              control={control}
              disabledSwitch={disabledSchedule}
              disabled={isDisabledFields}
              errors={errors}
              sxSelect={{
                border: `1px solid ${INPUT_COLOR_BORDER}`,
              }}
            />
            <Box sx={{ mt: 2 }}>
              <ClickableText
                onClick={() => onCopyValuesInOtherAds({ type: "schedule" })}
              >
                {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
              </ClickableText>
            </Box>
          </CardContainer>
        )}

        {/* Saved Audience */}
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <GroupsIcon sx={{ color: "#FFFFFF", width: 24, height: 24 }} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_SAVED_AUDIENCE_SUB_TITLE)}
              </Typography>
            </Box>
          }
        >
          <AdsGroupFormChooseSavedAudience
            BASIC_PATH={BASIC_PATH}
            disabled={isDisabledFields}
          />
        </CardContainer>

        {/* Audience Segmentation */}
        <CardContainer
          title={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <People
                sx={{
                  color: "#FFFFFF",
                  width: 24,
                  height: 24,
                  fontWeight: 600,
                }}
              />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t(ADS_CAMPAIGN_SEGMENTATION_SUB_TITLE)}
              </Typography>
            </Box>
          }
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {!hasSpecialAdCategories && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: 0.5,
                  }}
                >
                  <Typography variant="subtitle1">
                    {t(IS_ADVANTAGE_AUDIENCE_ACTIVE_PLACEHOLDER)}
                  </Typography>
                  <Controller
                    name={`${BASIC_PATH}.isAdvantageAudienceActive`}
                    control={control}
                    render={({ field }) => (
                      <Switch
                        disabled={isDisabledFields}
                        isActive={Boolean(field.value)}
                        labelActive={
                          IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER
                        }
                        labelDeactivate={
                          IS_ADVANTAGE_AUDIENCE_ACTIVE_DESCRIPTION_PLACEHOLDER
                        }
                        onChangeIsActive={(value) => {
                          field.onChange(value);
                        }}
                        sxLabel={{
                          ".MuiFormControlLabel-label": {
                            fontSize: "0.9rem",
                            fontWeight: 400,
                          },
                        }}
                      />
                    )}
                  />
                </Box>
                <Divider sx={{ my: 2, borderColor: INPUT_COLOR_BORDER }} />
              </>
            )}
            <AdsGroupFormCustomAudiencesList
              BASIC_PATH={BASIC_PATH}
              name={`${BASIC_PATH}.customAudiences`}
              control={control}
              disabled={isDisabledFields}
            />
            <Divider sx={{ my: 2, borderColor: INPUT_COLOR_BORDER }} />
            <AdsGroupFormCustomAudiencesList
              BASIC_PATH={BASIC_PATH}
              name={`${BASIC_PATH}.excludedCustomAudiences`}
              control={control}
              disabled={isDisabledFields}
              isExcludedAudiences={true}
            />
          </Box>
        </CardContainer>

        {/* Demographics & Targeting */}
        <Grid container spacing={3}>
          {/* Age & Gender */}
          <Grid item xs={12} md={6}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Person sx={{ color: "#FFFFFF", width: 24, height: 24 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(DEMOGRAPHICS_BASIC_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
            >
              <Box sx={{ spaceY: 4 }}>
                <Box>
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    {t(AGE_RANGE_PLACEHOLDER)}
                  </Typography>
                  <Controller
                    name={`${BASIC_PATH}.ageRange`}
                    control={control}
                    render={({ field }) => (
                      <Slider
                        {...field}
                        sx={{
                          width: "calc(100% - 24px)",
                          ml: 1,
                          ".MuiSlider-track": {
                            backgroundColor: "#000",
                            height: 4,
                          },
                          ".MuiSlider-rail": {
                            backgroundColor: "rgba(0,0,0,0.5)",
                            height: 4,
                          },
                          ".MuiSlider-mark": {
                            backgroundColor: "transparent",
                          },
                          ".MuiSlider-markLabel": {
                            color: "rgba(0,0,0,0.5)",
                          },
                          ".MuiSlider-markLabelActive": {
                            color: "#000",
                          },

                          ".MuiSlider-thumb": {
                            border: "1px solid #e1e1e1",
                            backgroundColor: "#fff",
                          },
                        }}
                        valueLabelDisplay="auto"
                        getAriaValueText={textNumberCompactFormat}
                        step={1}
                        marks={marksAge}
                        min={18}
                        max={65}
                        valueLabelFormat={textNumberCompactFormat}
                        disabled={isDisabledFields}
                      />
                    )}
                  />
                </Box>
                <Divider sx={{ borderColor: INPUT_COLOR_BORDER }} />
                <Box mt={4}>
                  <CheckBoxes
                    name={`${BASIC_PATH}.genders`}
                    disabled={isDisabledFields}
                    label={GENDERS_PLACEHOLDER}
                    options={[
                      {
                        key: "male",
                        label: MALES,
                      },
                      {
                        key: "female",
                        label: FEMALES,
                      },
                    ]}
                    control={control}
                    errors={errors}
                    rules={{
                      validate: () => {
                        if (!Object.values(genders).includes(true)) {
                          return t(FIELD_REQUIRED);
                        }
                      },
                    }}
                  />
                </Box>
              </Box>
            </CardContainer>
          </Grid>

          {/* Location */}
          <Grid item xs={12} md={6}>
            <CardContainer
              title={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LocationOnOutlined
                    sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {t(LOCATIONS_PLACEHOLDER)}
                  </Typography>
                </Box>
              }
              sxContainer={{
                height: "100%",
              }}
            >
              <SearchSegmentationsField
                name={`${BASIC_PATH}.locations`}
                type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_LOCATIONS_TYPE}
                mode="fetching"
                platform={platform}
                adAccountID={platformData?.adAccountID}
                integrationID={platformData?.integrationID}
                objective={objective}
                language={language}
                fullWidth
                variant="filled"
                disabled={isDisabledFields}
                control={control}
                errors={errors}
                rules={{
                  required: {
                    value: !hasCustomAudiences,
                    message: t(FIELD_REQUIRED),
                  },
                }}
              />
              <Box sx={{ mt: 0.5 }}>
                <ClickableText
                  onClick={() => onCopyValuesInOtherAds({ type: "locations" })}
                >
                  {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                </ClickableText>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Box
                  sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Typography variant="subtitle1">
                    {t(EXCLUDED_LOCATIONS_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
                <SearchSegmentationsField
                  name={`${BASIC_PATH}.excludedLocations`}
                  type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_LOCATIONS_TYPE}
                  mode="fetching"
                  platform={platform}
                  adAccountID={platformData?.adAccountID}
                  integrationID={platformData?.integrationID}
                  objective={objective}
                  language={language}
                  fullWidth
                  variant="filled"
                  disabled={isDisabledFields}
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: false,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
                <Box sx={{ mt: 0.5 }}>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "excludedLocations" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Box>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Box
                  sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Typography variant="subtitle1">
                    {t(LANGUAGES_PLACEHOLDER)}
                  </Typography>
                  <ChipOptional size="small" />
                </Box>
                <SelectLanguagesMetaForm
                  name={`${BASIC_PATH}.languages`}
                  control={control}
                  errors={errors}
                  disabled={isDisabledFields}
                />
                <Box>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "languages" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Box>
              </Box>
            </CardContainer>
          </Grid>
        </Grid>

        {/* Advanced Targeting */}
        <Box sx={{ spaceY: 3, width: "100%" }}>
          {/* Interests */}
          <Card
            sx={{
              mb: 3,
              backgroundColor: "fields.background",
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              boxShadow: BOX_SHADOW_THEME,
              borderRadius: BORDER_RADIUS,
              p: 1,
            }}
          >
            <CardHeader
              onClick={() => setInterestsOpen(!interestsOpen)}
              sx={{
                cursor: "pointer",
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Favorite
                      sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(INTERESTS_PLACEHOLDER)}
                    </Typography>
                  </Box>
                  {interestsOpen ? (
                    <KeyboardArrowUp sx={{ color: "#9CA3AF" }} />
                  ) : (
                    <KeyboardArrowDown sx={{ color: "#9CA3AF" }} />
                  )}
                </Box>
              }
            />
            {interestsOpen && (
              <CardContent>
                <SearchSegmentationsField
                  name={`${BASIC_PATH}.interests`}
                  type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_INTERESTS_TYPE}
                  mode="fetching"
                  platform={platform}
                  adAccountID={platformData?.adAccountID}
                  integrationID={platformData?.integrationID}
                  objective={objective}
                  language={language}
                  fullWidth
                  variant="filled"
                  disabled={isDisabledFields}
                  helperText={
                    hasCustomAudiences
                      ? t(RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION)
                      : ""
                  }
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: false,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
                <Box sx={{ mt: 1 }}>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "interests" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Box>
              </CardContent>
            )}
          </Card>

          {/* Behaviors */}
          <Card
            sx={{
              mb: 3,
              backgroundColor: "fields.background",
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              boxShadow: BOX_SHADOW_THEME,
              borderRadius: BORDER_RADIUS,
              p: 1,
            }}
          >
            <CardHeader
              onClick={() => setBehaviorOpen(!behaviorOpen)}
              sx={{
                cursor: "pointer",
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <TrendingUp
                      sx={{ color: "#FFFFFF", width: 24, height: 24 }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(BEHAVIORS_PLACEHOLDER)}
                    </Typography>
                  </Box>
                  {behaviorOpen ? (
                    <KeyboardArrowUp sx={{ color: "#9CA3AF" }} />
                  ) : (
                    <KeyboardArrowDown sx={{ color: "#9CA3AF" }} />
                  )}
                </Box>
              }
            />
            {behaviorOpen && (
              <CardContent>
                <SearchSegmentationsField
                  name={`${BASIC_PATH}.behaviors`}
                  type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_BEHAVIORS_TYPE}
                  mode="load"
                  groupBy={["path", 0]}
                  platform={platform}
                  adAccountID={platformData?.adAccountID}
                  integrationID={platformData?.integrationID}
                  objective={objective}
                  language={language}
                  fullWidth
                  variant="filled"
                  disabled={isDisabledFields}
                  helperText={
                    hasCustomAudiences
                      ? t(RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION)
                      : ""
                  }
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: false,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
                <Box sx={{ mt: 1 }}>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "behaviors" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Box>
              </CardContent>
            )}
          </Card>

          {/* Demographics */}
          <Card
            sx={{
              mb: 3,
              backgroundColor: "fields.background",
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              boxShadow: BOX_SHADOW_THEME,
              borderRadius: BORDER_RADIUS,
              p: 1,
            }}
          >
            <CardHeader
              onClick={() => setDemographyOpen(!demographyOpen)}
              sx={{
                cursor: "pointer",
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <People
                      sx={{
                        color: "#FFFFFF",
                        width: 24,
                        height: 24,
                        fontWeight: 600,
                      }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(DEMOGRAPHICS_PLACEHOLDER)}
                    </Typography>
                  </Box>
                  {demographyOpen ? (
                    <KeyboardArrowUp sx={{ color: "#9CA3AF" }} />
                  ) : (
                    <KeyboardArrowDown sx={{ color: "#9CA3AF" }} />
                  )}
                </Box>
              }
            />
            {demographyOpen && (
              <CardContent>
                <SearchSegmentationsField
                  name={`${BASIC_PATH}.demographics`}
                  type={ADS_CAMPAIGN_SEARCH_SEGMENTATION_DEMOGRAPHICS_TYPE}
                  mode="load"
                  groupBy={["path", 0]}
                  platform={platform}
                  adAccountID={platformData?.adAccountID}
                  integrationID={platformData?.integrationID}
                  objective={objective}
                  language={language}
                  fullWidth
                  variant="filled"
                  disabled={isDisabledFields}
                  helperText={
                    hasCustomAudiences
                      ? t(RETARGETING_EMPTY_SEGMENTATION_CLARIFICATION)
                      : ""
                  }
                  control={control}
                  errors={errors}
                  rules={{
                    required: {
                      value: false,
                      message: t(FIELD_REQUIRED),
                    },
                  }}
                />
                <Box sx={{ mt: 1 }}>
                  <ClickableText
                    onClick={() =>
                      onCopyValuesInOtherAds({ type: "demographics" })
                    }
                  >
                    {t(COPY_VALUE_IN_OTHER_ADGROUPS)}
                  </ClickableText>
                </Box>
              </CardContent>
            )}
          </Card>

          {/* Placements */}
          <Card
            sx={{
              mb: 3,
              backgroundColor: "fields.background",
              border: `1px solid ${INPUT_COLOR_BORDER}`,
              boxShadow: BOX_SHADOW_THEME,
              borderRadius: BORDER_RADIUS,
              p: 1,
            }}
          >
            <CardHeader
              sx={{
                cursor: "pointer",
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <People
                      sx={{
                        color: "#FFFFFF",
                        width: 24,
                        height: 24,
                        fontWeight: 600,
                      }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {t(PLACEMENTS_PLACEHOLDER)}
                    </Typography>
                  </Box>
                </Box>
              }
            />
            <CardContent>
              <AdGroupPlacementsMetaForm
                control={control}
                name={`${BASIC_PATH}.placements`}
                disabled={isDisabledFields}
              />
            </CardContent>
          </Card>
        </Box>
      </Box>

      {/* Audience Preview - Responsive */}
      <Box
        sx={{
          width: isTabletOrMobile || showSlideChat ? "100%" : "400px",
          position: isTabletOrMobile || showSlideChat ? "static" : "sticky",
          top: isTabletOrMobile || showSlideChat ? "auto" : 0,
          alignSelf: "flex-start",
          height: "fit-content",
          overflow: "auto",
          order: isTabletOrMobile || showSlideChat ? 1 : 2,
        }}
      >
        <AudienceEstimatesPreviewMeta BASIC_PATH={BASIC_PATH} />
      </Box>
    </Box>
  );
};

export default AdGroupMetaForm;
